import './Login.scss';

import React, { useState } from 'react';

import { Button, InputField } from '@bblabs/module-library/atoms';
import { NoticeBanner } from '@bblabs/module-library/molecules';
import { environment, getUrlsForEnvironment } from '../../environment';
import { isConfiguredForFidelity } from '../lib/host';
import type { AppLoginState } from './App';

type Props = {
  onLoginClick?(): void;
  onLoginCodeClick?(loginCode: string): Promise<{ success: boolean }> | void;
  onSignupClick?(): void;
  message?: string;
  state: AppLoginState;
};

const noOp = () => {
  /* intentional */
};

export function Login({
  onLoginClick = noOp,
  onSignupClick = noOp,
  message = '',
  state,
  onLoginCodeClick = noOp,
}: Props) {
  const [loginView, setLoginView] = useState<'normal' | 'code'>('normal');
  const [loginCode, setLoginCode] = useState('');
  const [loginMessage, setLoginMessage] = useState('');
  const urls = getUrlsForEnvironment(environment);

  function changeLoginView() {
    setLoginMessage('');
    setLoginView(loginView === 'normal' ? 'code' : 'normal');
  }

  async function handleCodeLogin() {
    if (!loginCode) {
      return;
    }

    const result = await onLoginCodeClick(loginCode);
    if (result && !result.success) {
      setLoginMessage('Verification code invalid. Please get another code');
    }
  }

  return (
    <div className="view--login">
      <header>
        <h1>Welcome to</h1>
        <h1 className="app-name">BombBomb for Outlook</h1>
      </header>

      <hr />

      {message && (
        <div className="message">
          <NoticeBanner noticeText={message} type="none" />
        </div>
      )}

      {loginView === 'normal' && (
        <>
          <p className="info">
            Supplement your text-based emails with 1:1 videos that are more personal and engaging.
          </p>

          <div className="buttons">
            {!isConfiguredForFidelity() && (
              <Button
                disabled={state !== false}
                label="Sign Up"
                color="traffic-cone"
                onClick={onSignupClick}
                rectangle
                size="large"
                type="button"
              />
            )}
            <Button
              disabled={state !== false}
              label="Log In"
              color="traffic-cone"
              onClick={onLoginClick}
              rectangle
              outline={!isConfiguredForFidelity()}
              size="large"
              type="button"
            />
          </div>

          {!isConfiguredForFidelity() && (
            <p className="login-with-code" onClick={changeLoginView}>
              <a href={`${urls.appUrl}/app/?module=users&page=login_code`} target="_blank" rel="noreferrer">
                Login with code
              </a>
            </p>
          )}
        </>
      )}
      {loginView === 'code' && (
        <>
          <InputField
            labelName="Verification Code"
            name="verification_code"
            onChange={(_n, value) => setLoginCode(value.toUpperCase())}
            placeholder="placeholder"
            showLabel
            showSuccess={false}
            type="text"
            value={loginCode}
          />
          <div className="buttons">
            <Button
              label="Log In"
              color="traffic-cone"
              onClick={handleCodeLogin}
              rectangle
              size="large"
              type="button"
            />
            <div className="get-another">
              <a href={`${urls.appUrl}/app/?module=users&page=login_code`} target="_blank" rel="noreferrer">
                Get Another Code
              </a>
            </div>
          </div>
          <p className="login-with-code" onClick={changeLoginView} role="button">
            Cancel
          </p>

          {loginMessage && <p className="error-message">{loginMessage}</p>}
        </>
      )}
    </div>
  );
}
